var _circle, _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 70,
    viewBox: "0 0 75 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 42,
    r: 28,
    fill: "#EEE7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29607_5061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9585 19.4089L22.2874 29.5028C20.687 29.9317 19.7373 31.5767 20.1661 33.1771L27.1542 59.2571C27.583 60.8575 29.2281 61.8072 30.8285 61.3784L68.4996 51.2844C70.1 50.8556 71.0497 49.2106 70.6209 47.6102L63.6328 21.5302C63.2039 19.9298 61.5589 18.9801 59.9585 19.4089Z",
    fill: "#C9B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4441 38.7782C22.3369 38.3781 22.5743 37.9668 22.9744 37.8596L63.5433 26.9892C63.9434 26.882 64.3547 27.1194 64.4619 27.5195C64.5691 27.9196 64.3317 28.3309 63.9316 28.4381L23.3627 39.3085C22.9626 39.4157 22.5513 39.1783 22.4441 38.7782Z",
    fill: "#EEE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0174 45.5301C31.9102 45.13 32.1476 44.7188 32.5477 44.6115L48.4855 40.341C48.8856 40.2338 49.2968 40.4713 49.404 40.8714C49.5112 41.2715 49.2738 41.6827 48.8737 41.7899L32.9359 46.0604C32.5358 46.1676 32.1246 45.9302 32.0174 45.5301Z",
    fill: "#EEE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5701 51.326C33.4629 50.9259 33.7003 50.5147 34.1004 50.4074L44.2426 47.6898C44.6427 47.5826 45.054 47.8201 45.1612 48.2202C45.2684 48.6203 45.031 49.0315 44.6309 49.1387L34.4886 51.8563C34.0885 51.9635 33.6773 51.7261 33.5701 51.326Z",
    fill: "#EEE7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9897 1.1573C55.7914 2.40962 55.2841 3.59337 54.5142 4.60088C54.2979 4.88405 54.2429 5.25829 54.3753 5.58923C54.5077 5.91997 54.8057 6.15307 55.1575 6.20881C56.4099 6.40709 57.5936 6.91438 58.6011 7.68429C58.8843 7.90067 59.2585 7.95564 59.5895 7.82324C59.9202 7.6908 60.1533 7.39278 60.2091 7.04078C60.4074 5.78846 60.9146 4.60492 61.6845 3.59741C61.9009 3.31424 61.9559 2.93999 61.8235 2.60905C61.6911 2.27832 61.393 2.04522 61.0412 1.98947C59.7889 1.79119 58.6054 1.28393 57.5979 0.514023C57.3147 0.297648 56.9404 0.242671 56.6095 0.375075C56.2786 0.507281 56.0455 0.805307 55.9897 1.1573Z",
    fill: "#FFE5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01784 59.5926C0.916406 60.2332 0.656906 60.8388 0.263058 61.3542C0.152372 61.499 0.124249 61.6905 0.19198 61.8597C0.259726 62.0289 0.412179 62.1482 0.592142 62.1767C1.23276 62.2781 1.83831 62.5376 2.3537 62.9315C2.49856 63.0422 2.69 63.0703 2.85929 63.0026C3.02848 62.9348 3.14772 62.7824 3.17625 62.6023C3.27768 61.9617 3.53717 61.3562 3.93102 60.8408C4.0417 60.696 4.06983 60.5045 4.0021 60.3352C3.93435 60.1661 3.78189 60.0468 3.60193 60.0183C2.96131 59.9169 2.35587 59.6574 1.84048 59.2635C1.69562 59.1528 1.50418 59.1247 1.33489 59.1925C1.16561 59.2601 1.04637 59.4125 1.01784 59.5926Z",
    fill: "#C9B3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29607_5061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 23.4229) rotate(-15)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.b8a8c4bd3dfebcea9b6a7d4275664626.svg";
export { ForwardRef as ReactComponent };